<template>
  <v-app id="app">
    <router-view/>
  </v-app>
</template>

<script>
import axios from 'axios'

export default {
  async created () {
    require('./registerServiceWorker')

    document.querySelectorAll("link[rel='icon']").forEach(e => e.parentNode.removeChild(e))
    this.generateManifest()
    const faviconUrl = await this.fetchFavicon()
    this.generateFavicon(faviconUrl)
  },

  methods: {
    async fetchFavicon () {
      const BASE_URL = window.location.port ? ('http://' + window.location.hostname + ':5000') : ('https://staging.browseandgo.fr')

      try {
        const owner = await axios.get(`${BASE_URL}/pass/owner?customer_key=${this.$route.params.apiKey}`)

        const mainColor = owner.data.company.main_color
        this.$vuetify.theme.primary = mainColor

        document.title = owner.data.company.name
        this.$store.dispatch('setOwner', owner.data)

        return owner.data.company.favicon_url
      } catch (err) {
      }
    },
    generateManifest () {
      document.querySelectorAll("[rel='manifest']")[0].setAttribute('href', `https://manifestgen.browseandgo.fr/bgmanifest.json?server=pass&apiUrl=${this.$route.params.offerId}/${this.$route.params.apiKey}`)
    },
    generateFavicon (faviconUrl) {
      let link = document.createElement('link')
      link.rel = 'icon'
      link.href = faviconUrl

      document.getElementsByTagName('head')[0].appendChild(link)
      document.querySelector("[rel='apple-touch-icon']").setAttribute('href', faviconUrl)
    }
  }
}
</script>
